import { useAssignWizard } from 'pages/custom_tests_v1/components/assign_wizard/context';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { Button, Col, ListGroup, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';

export const SelectionStep = () => {

    const { initialSelectedAccessCodes, initialSelectedClassrooms, loading, openAccessCodePicker: launchAccessCodePicker,
        openClassroomPicker: launchClassroomPicker, selectedAccessCodes, selectedClassrooms, setSelectedAccessCodes,
        setSelectedClassrooms } = useAssignWizard();
    const { formatMessage } = useIntl();

    const assignedAccessCodeIds = initialSelectedAccessCodes.map(({ Id }) => Id);
    const assignedClassroomIds = initialSelectedClassrooms.map(({ Id }) => Id);

    const removeAccessCode = (id: number) => setSelectedAccessCodes(selectedAccessCodes.filter(({ Id }) => Id !== id));

    const removeClassroom = (id: number) => setSelectedClassrooms(selectedClassrooms.filter(({ Id }) => Id !== id));

    return (
        <>
            <div className={'mb-3'}>
                <p className={'text-muted mb-2'}>
                    {formatMessage({ id: 'choose_which_access_codes_and_classrooms.3d3a8a5a', defaultMessage: 'Choose which access codes and classrooms this test is assigned to. Add new items, or remove any item to unassign it. Changes are applied when you finish the wizard.' })}
                </p>
                <div className={'d-flex flex-wrap gap-3 small'}>
                    <span className={'d-inline-flex align-items-center gap-1'}>
                        <span className={'badge bg-primary'}>
                            {formatMessage({ id: 'new.03d9347f', defaultMessage: 'New' })}
                        </span>
                        {formatMessage({ id: 'will_be_assigned.60206348', defaultMessage: 'Will be assigned' })}
                    </span>
                </div>
            </div>

            <Row className={'selection-step d-flex flex-column flex-xl-row'}>
                <Col className={'access-codes'} xl={6} xs={12}>
                    <h6>
                        {formatMessage({ id: 'access_codes.3114ae04', defaultMessage: 'Access Codes' })}
                    </h6>
                    {loading ?
                        (
                            <div className={'d-flex align-items-center justify-content-center p-5 border rounded bg-body-secondary'}>
                                <GMetrixLoader />
                            </div>
                        )
                        :
                        (
                            <>
                                {selectedAccessCodes?.length ?
                                    (
                                        <div className={'d-flex flex-column gap-3 p-3 border rounded bg-body-tertiary'}>
                                            <Button onClick={launchAccessCodePicker}>
                                                {formatMessage({ id: 'select_access_codes.11a08246', defaultMessage: 'Select Access Codes' })}
                                            </Button>

                                            <ListGroup>
                                                {selectedAccessCodes.map(({ Id, Identifier }) => (
                                                    <ListGroup.Item className={'d-flex align-items-center justify-content-between gap-2'} key={Id}>
                                                        <span className={'d-flex align-items-center gap-2 overflow-hidden'}>
                                                            {!assignedAccessCodeIds.includes(Id) && (
                                                            <span className={'badge bg-primary'}>
                                                                {formatMessage({ id: 'new.03d9347f', defaultMessage: 'New' })}
                                                            </span>
                                                            )}
                                                            <span className={'fw-semibold text-truncate'}>
                                                                {Identifier}
                                                            </span>
                                                        </span>
                                                        <Button
                                                            className={'text-muted p-0'}
                                                            onClick={() => removeAccessCode(Id)}
                                                            title={formatMessage({ id: 'remove.d34ac1e7', defaultMessage: 'Remove' })}
                                                            variant={'link'}
                                                        >
                                                            <i className="fa-solid fa-xmark" />
                                                        </Button>
                                                    </ListGroup.Item>
                                                ))}

                                            </ListGroup>
                                        </div>
                                    )
                                    :
                                    (
                                        <div className={'d-flex align-items-center justify-content-center p-5 border rounded bg-body-tertiary'}>
                                            <Button onClick={launchAccessCodePicker} variant={'outline-primary'}>
                                                {formatMessage({ id: 'select_access_codes.11a08246', defaultMessage: 'Select Access Codes' })}
                                            </Button>
                                        </div>
                                    )
                                }
                            </>
                        )
                    }
                </Col>

                <Col className={'classrooms'} xl={6} xs={12}>
                    <h6>
                        {formatMessage({ id: 'classrooms.e66138fb', defaultMessage: 'Classrooms' })}
                    </h6>

                    {loading ?
                        (
                            <div className={'d-flex align-items-center justify-content-center p-5 border rounded bg-body-secondary'}>
                                <GMetrixLoader />
                            </div>
                        )
                        :
                        (
                            <>
                                {selectedClassrooms?.length ?
                                    (
                                        <div className={'d-flex flex-column gap-3 p-3 border rounded bg-body-tertiary'}>

                                            <Button onClick={launchClassroomPicker}>
                                                {formatMessage({ id: 'select_classrooms.f1589a6f', defaultMessage: 'Select Classrooms' })}
                                            </Button>

                                            <ListGroup>
                                                {selectedClassrooms.map(({ Id, Name }) => (
                                                    <ListGroup.Item className={'d-flex align-items-center justify-content-between gap-2'} key={Id}>
                                                        <span className={'d-flex align-items-center gap-2 overflow-hidden'}>
                                                            {!assignedClassroomIds.includes(Id) && (
                                                            <span className={'badge bg-primary'}>
                                                                {formatMessage({ id: 'new.03d9347f', defaultMessage: 'New' })}
                                                            </span>
                                                            )}
                                                            <span className={'fw-semibold text-truncate'}>
                                                                {Name}
                                                            </span>
                                                        </span>
                                                        <Button
                                                            className={'text-muted p-0'}
                                                            onClick={() => removeClassroom(Id)}
                                                            title={formatMessage({ id: 'remove.d34ac1e7', defaultMessage: 'Remove' })}
                                                            variant={'link'}
                                                        >
                                                            <i className="fa-solid fa-xmark" />
                                                        </Button>
                                                    </ListGroup.Item>
                                                ))}

                                            </ListGroup>
                                        </div>
                                    )
                                    :
                                    (
                                        <div className={'d-flex align-items-center justify-content-center p-5 border rounded bg-body-tertiary'}>
                                            <Button onClick={launchClassroomPicker} variant={'outline-primary'}>
                                                {formatMessage({ id: 'select_classrooms.f1589a6f', defaultMessage: 'Select Classrooms' })}
                                            </Button>
                                        </div>
                                    )
                                }
                            </>
                        )
                    }

                </Col>
            </Row>

        </>
    );

};